module.exports = __webpack_public_path__ + "static/media/in_app_notifications.96c0cc24.png";